import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/I18nContext";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b31fc984-f212-4811-9faa-4930fd1aea96/artifacts/naoml62k_image.png";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-neutral-800 bg-neutral-900 shadow-2xl">
        <CardContent className="p-8 text-center">
          <img src={LOGO_URL} alt="Logo" className="h-16 mx-auto mb-6" />
          
          <div className="w-16 h-16 rounded-full bg-amber-600/20 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-8 h-8 text-amber-500" />
          </div>
          <h2 className="text-2xl font-bold text-white font-['Nunito']">{t("payment_cancelled")}</h2>
          <p className="text-neutral-400 mt-2">{t("payment_cancelled_msg")}</p>
          <Button 
            className="mt-6 bg-red-600 hover:bg-red-700 text-white rounded-lg px-8"
            onClick={() => navigate("/dashboard")}
            data-testid="go-dashboard-cancel-btn"
          >
            {t("go_dashboard_back")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
